export default "__VITE_ASSET__C9zZW3LI__"